"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RmqProviderType = void 0;
var RmqProviderType;
(function (RmqProviderType) {
    RmqProviderType["EML_SERVICE"] = "EML_SERVICE";
    RmqProviderType["WEBHOOK_SERVICE"] = "WEBHOOK_SERVICE";
    RmqProviderType["CRON_SERVICE"] = "CRON_SERVICE";
    RmqProviderType["MOBILE_SERVICE"] = "MOBILE_SERVICE";
    RmqProviderType["GAME_SERVICE"] = "GAME_SERVICE";
    RmqProviderType["SIGNAL_SERVICE"] = "SIGNAL_SERVICE";
})(RmqProviderType || (exports.RmqProviderType = RmqProviderType = {}));
//# sourceMappingURL=provider.js.map